function isValidETHAddress(str: string) {
  if (str === null) return false

  const regex = new RegExp(/^(0x)[0-9a-fA-F]{40}$/)
  if (regex.test(str) === true) return true
  return false
}

function isValidPassword(str: string) {
  if (str === null) return false

  const regex = new RegExp(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=[\]{};':",.<>?/\\|`~]).{8,256}$/
  )
  if (regex.test(str) === true) return true
  return false
}

function validatePoolDuration(input: any) {
  const parts = input.trim().split(/\s+/)

  for (let i = 0; i < parts.length; i += 2) {
    if (i + 1 >= parts.length) {
      return {
        valid: false,
        message: `Every number must be followed by a unit like "days", "months" or "years"`,
      }
    }

    const num = parts[i]
    const unit = parts[i + 1]

    if (!/^\d+$/.test(num)) {
      return { valid: false, message: 'All numbers must be positive integers.' }
    }

    const unitPattern = num === '1' ? /^(day|month|year)$/ : /^(days|months|years)$/

    if (!unitPattern.test(unit)) {
      return {
        valid: false,
        message:
          'Units must be "day", "month", "year" for number 1 or "days", "months", "years" for bigger number 1.',
      }
    }
  }

  return { valid: true, message: 'Valid input!' }
}

const validateLink = (value: string) => {
  const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i
  if (value && !urlPattern.test(value)) {
    alert('Invalid link format.')
  }
}

export { isValidETHAddress, isValidPassword, validateLink, validatePoolDuration }
